<template>
  <div id="app">
    <vue-particles :color="particles.color" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle"
      :particleSize="4" :linesColor="particles.color" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4"
      :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push"
      :style="{ 'background-color': particles.background_color }">
    </vue-particles>

    <div class="box">
      <dv-border-box-7 :color="[dvBorderBox.bgColor, dvBorderBox.bgColor2]">
        <div class="login_sign">
          <div class="logo">
            <img :src="logo" />
          </div>
          <div style="margin: 2rem 2rem 0 2rem">
            <el-input :placeholder="langList.username ? langList.username : '用户名'" type="text" ref="username"
              v-model="username">
              <template slot="prepend"><i class="iconfont icon-zhcc_yonghuming"></i></template>
            </el-input>
          </div>
          <div style="margin: 0.75rem 2rem 0 2rem">
            <el-input :placeholder="langList.password ? langList.password : '密码'" ref="password" v-model="password"
              type="password">
              <template slot="prepend"><i class="iconfont icon-mima"></i></template>
            </el-input>
          </div>
          <div style="margin: 0.75rem 2rem 0 2rem">
            <el-input :placeholder="langList.captcha ? langList.captcha : '验证码'" ref="captcha" v-model="captchaKey"
              style="width: 58%">
              <template slot="prepend"><i class="iconfont icon-yanzhengma"></i></template>
            </el-input>
            <div style="margin-left: 10px; float: right; cursor: pointer">
              <img style="width: 6.5625rem; height: 2.5rem" :src="captcha" v-on:click="captchImg"
                :alt="langList.captchaalt ? langList.captchaalt : '点击更新'" class="layadmin-user-login-codeimg"
                id="LAY-user-get-vercode" />
            </div>
          </div>
          <div style="margin: 0.75rem 2rem 0 2rem">
            <el-select :value="lang" :placeholder="langList.lang ? langList.lang : '请选择语言'" style="width: 58%"
              @change="selectLangChang">
              <el-option class="configCompany" v-for="item in langTypeList" :key="item.id" :label="item.name"
                :value="item.id" style="padding: 6px">
              </el-option>
            </el-select>
          </div>
          <div style="margin: 0.75rem 2rem 0 2rem">
            <el-button type="success" :loading="successLoading" :style="{
              width: '85%',
              'background-color': particles.login_button_background_color,
              'border-color': particles.login_button_background_color,
              color: particles.login_button_color,
            }" @click="login">{{ langList.login ? langList.login : "登录" }}</el-button>
          </div>
        </div>
      </dv-border-box-7>
    </div>

    <div class="login_footer" :style="{
      color: particles.footer_color,
      'background-color': particles.footer_background_color,
    }">
      <div class="footer_left">
        <div class="left_box">
          <div class="left_text">{{ this.company }}</div>
          <div class="left_text">{{ this.companyEn }}</div>
          <div class="left_text">{{ this.copyright }}</div>
        </div>
      </div>
      <div class="footer_center">
        <div class="center_box">
          <div class="center_text">{{ this.contactTel }}</div>
          <div class="center_text">{{ this.contactAddress }}</div>
          <div class="center_text">{{ this.contactEmail }}</div>
        </div>
      </div>
      <div class="footer_right" v-if="this.company">
        <div v-if="lang == 1">
          技术支持：<a :style="{ color: particles.footer_color }" href="https://www.jz-iot.net">深圳市集智电子有限公司</a>
        </div>
        <div v-else>
          TS:
          <a :style="{ color: particles.footer_color }" href="https://www.jz-iot.net">Shenzhen Jizhi Electronics Co.,
            Ltd.</a>
        </div>
      </div>
      <div class="footer_right">
        <img src="../../assets/default/tbdappewm.png" style="
            width: 6rem;
            height: 6rem;
            float: right;
            margin-top: 1rem;
            margin-right: 2rem;
          " />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data () {
    return {
      routeTab: null,
      particles: {
        color: '#dedede',
        background_color: '#1F2D3D',
        login_button_color: '#ffffff',
        login_button_background_color: '#246fbf',
        footer_color: '#ffffff',
        footer_background_color: '#000000'
      },
      forgetThePassword: false,
      dvBorderBox: {
        // bgColor: 'rgba(101, 231, 250, .4)',
        bgColor: 'rgba(37, 109, 203, .6)',
        // bgColor2: '#65e7fa',
        bgColor2: '#00a0e9'
      },
      successLoading: false,
      captcha: null,
      captchaCKey: null,
      password: '',
      username: '',
      captchaKey: '',
      logo: '',
      company: '',
      companyEn: '',
      copyright: '',
      contactTel: '',
      contactAddress: '',
      contactEmail: '',
      lang: 0,
      langTypeList: [],
      langList: {},
    }
  },
  created: function () { //钩子函数
    this.routeTab = this.company + '平台登录'
    this.langTypeData()
    this.config()
    this.captchImg()
  },
  mounted () {
    var lang = translate.language.getCurrent()
    console.log(lang, '语言')
    if (lang == 'english') {
      this.lang = 2
    } else {
      this.lang = 1
    }
    this.GLOBAL.lang = this.lang
    this.$cookies.set('lang', this.lang)
    sessionStorage.setItem('lang', this.lang)
    this.getLangList()
  },
  methods: {
    langTypeData: function () {
      this.axios.get(this.api.ApiUrl.langtype).then((result) => {
        let langTypeData = result.data
        if (langTypeData.code == 20000) {
          this.GLOBAL.langTypeList = langTypeData.data
          this.GLOBAL.lang = Number(sessionStorage.getItem('lang'))
          if (this.GLOBAL.lang == '' || this.GLOBAL.lang == null || this.GLOBAL.lang == undefined) {
            this.GLOBAL.lang = Number(this.GLOBAL.langTypeList[0].id)
          }
        }
        this.lang = this.GLOBAL.lang
        this.langTypeList = this.GLOBAL.langTypeList
        this.getLangList()
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    getLangList: function () {
      this.axios.get(this.api.ApiUrl.lang + '?lang=' + this.lang + '&type=1').then((result) => {
        let langData = result.data
        if (langData.code == 20000) {
          this.GLOBAL.langList = langData.data
          this.langList = this.GLOBAL.langList
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    config: function () {
      this.axios.get(this.api.ApiUrl.config).then((result) => {
        var configData = result.data
        if (configData.code == 20000) {
          this.GLOBAL.companyUrl = configData.data.url
          this.GLOBAL.logo = configData.data.logo
          this.GLOBAL.company = configData.data.company
          this.GLOBAL.companyEn = configData.data.companyEn
          this.GLOBAL.copyright = configData.data.copyright
          this.GLOBAL.contactTel = configData.data.contactTel
          this.GLOBAL.contactAddress = configData.data.contactAddress
          this.GLOBAL.contactEmail = configData.data.contactEmail
          this.particles = configData.data.particles
          this.logo = this.GLOBAL.logo
          this.company = this.GLOBAL.company
          this.companyEn = this.GLOBAL.companyEn
          this.copyright = this.GLOBAL.copyright
          this.contactTel = this.GLOBAL.contactTel
          this.contactAddress = this.GLOBAL.contactAddress
          this.contactEmail = this.GLOBAL.contactEmail
          console.log(this.particles)
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    captchImg: function () {
      this.axios.get(this.api.ApiUrl.captchaInfo).then((result) => {
        var captchaData = result.data
        if (captchaData.code == 20000) {
          this.captcha = captchaData.data.img
          this.captchaCKey = captchaData.data.key
          console.log(captchaData)
        }
      }).catch(error => {
        console.log(error)
        this.errored = true
      })
    },
    login: function () {
      var username = this.$refs.username.value
      var password = this.$refs.password.value
      var captcha = this.$refs.captcha.value
      this.axios.post(this.api.ApiUrl.login, { 'username': username, 'password': password, 'captcha': captcha, 'key': this.captchaCKey }).then((result) => {
        var loginData = result.data
        if (loginData.code == 20000) {
          this.GLOBAL.token = loginData.data.token
          this.GLOBAL.user = loginData.data.user
          this.GLOBAL.token_expires_in = loginData.data.expires_in
          this.$cookies.set('token', this.GLOBAL.token)
          sessionStorage.setItem('token', this.GLOBAL.token)
          this.$cookies.set('user', JSON.stringify(this.GLOBAL.user))
          sessionStorage.setItem('user', JSON.stringify(this.GLOBAL.user))
          this.$cookies.set('token_expires_in', JSON.stringify(this.GLOBAL.token_expires_in))
          sessionStorage.setItem('token_expires_in', JSON.stringify(this.GLOBAL.token_expires_in))
          this.$message({
            message: (this.langList.loginSuccessMsg) ? this.langList.loginSuccessMsg : '登录成功',
            type: 'success'
          })
          if (this.GLOBAL.ws && this.GLOBAL.ws.readyState == 1) {
            this.GLOBAL.ws.send('{"Type":1100,"user_id":' + this.GLOBAL.user.id + ',"txnNo":' + Date.parse(new Date()) + '}')
          }
          this.$router.push({ path: '/index' })
        } else {
          var msg = ''
          if (loginData.code == 40004) {
            msg = (this.langList.loginErrorCaptchMsg) ? this.langList.loginErrorUserPawMsg : '验证码错误'
          } else if (loginData.code == 40005) {
            msg = (this.langList.loginErrorUserPawMsg) ? this.langList.loginErrorUserPawMsg : '用户名或密码错误'
          }
          this.$message.error(loginData.message)
        }
      })
    },
    selectLangChang: function (l) {
      this.lang = Number(l)
      console.log(l)
      if (l == 1) {
        translate.changeLanguage('chinese_simplified')
      } else if (l == 2) {
        translate.changeLanguage('english')
      }
      this.GLOBAL.lang = this.lang
      this.$cookies.set('lang', this.lang)
      sessionStorage.setItem('lang', this.lang)
      this.getLangList()
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: content-box;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

canvas {
  display: block;
  vertical-align: bottom;
}

#particles-js {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 99%;
  background-color: #1f2d3d;
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
}

.particles-content {
  position: absolute;
  width: 21.875rem;
  height: 23.5rem;
  z-index: 100;
  left: 50%;
  top: 45%;
  margin-left: -10.9375rem;
  margin-top: -11.75rem;
}

.logo {
  margin: 1.25rem auto 0 auto;
  width: 100%;
  height: 3.5rem;
  text-align: center;
  border-bottom: 0.05px solid #e6e6e6;
}

.box {
  width: 21.875rem;
  height: 23.5rem;
  position: absolute;
  right: 16%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  box-sizing: border-box;
}

.box .bor_box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}

.logo img {
  height: 70%;
}

.login_sign {
  width: 21.875rem;
  height: 23.5rem;
  /* background-color: #f4f4f4;
  border: 0.0625rem solid #e6e6e6; */
  /* border-radius: 0.3125rem; */
  /* box-shadow: 0.0625rem 0.0625rem 0.625rem #666; */
}

.login_sign .sign_title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 0.875rem;
  font-family: 微软雅黑;
  text-align: center;
  border-bottom: 0.0625rem solid rgb(230, 230, 230);
}

.login_footer {
  height: 8rem;
  line-height: 8rem;
  width: 100%;
  position: absolute;
  z-index: 100;
  bottom: 0;
}

.login_footer .footer_left {
  width: 30%;
  float: left;
}

.login_footer .footer_left .left_box {
  width: 19rem;
  margin: 2.1rem auto;
}

.login_footer .footer_left .left_box .left_text {
  line-height: 1.25rem;
}

.login_footer .footer_center {
  width: 40%;
  float: left;
}

.login_footer .footer_center .center_box {
  width: 24rem;
  margin: 2.1rem auto;
}

.login_footer .footer_center .center_box .center_text {
  line-height: 1.25rem;
}

.login_footer .footer_right {
  width: 30%;
  float: left;
}

.footer_right a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue